export default "__VITE_ASSET__BigbRsN8__"